<template>
  <div>
    <div class="enquire-modal modal" :class="{'is-active': showThankyou}">
      <div class="modal-background" @click="showThankyou=false"></div>
      <div class="modal-content">
        <div class="box has-text-centered">
          <h4>Thank you!</h4>
          <p class="pb-2">We will be in touch with you shortly.</p>
          <p class="control my-2">
            <a class="button app-primary" @click="showThankyou = false">Ok</a>
          </p>
        </div>
      </div>
    </div>

    <div class="enquire-modal modal" :class="{'is-active': showEnquiry}">
      <div class="modal-background" @click="closeEnquiry()"></div>
      <div class="modal-content">
        <div class="box">
          <h4>Can't Find What You're Looking For? Let Us Help You!</h4>
          <div class="columns is-multiline">
            <div class="column is-6">
              <div class="field">
                <p class="label">First Name*</p>
                <p class="control">
                  <input class="input" type="text" placeholder="First Name" v-model="enquiry.firstname" :change="checkValidation()" required>
                </p>
                <p class="pt-2 has-text-danger" v-if="!validName(enquiry.firstname) && submitClicked">*Please enter a valid First Name</p>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <p class="label">Last Name*</p>
                <p class="control">
                  <input class="input" type="text" placeholder="Last Name" v-model="enquiry.lastname" :change="checkValidation()" required>
                </p>
                <p class="pt-2 has-text-danger" v-if="!validName(enquiry.lastname) && submitClicked">*Please enter a valid Last Name</p>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <p class="label">Email*</p>
                <p class="control">
                  <input class="input" type="email" placeholder="Email" v-model="enquiry.email" :change="checkValidation()" required>
                </p>
                <p class="pt-2 has-text-danger" v-if="!validEmail(enquiry.email) && submitClicked">*Please enter a valid Email</p>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <p class="label">Phone</p>
                <p class="control">
                  <input class="input" type="email" placeholder="Phone" v-model="enquiry.phone">
                </p>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <p class="label">Price Range</p>
                <div class="control radio-group">
                  <label class="radio">
                    <input type="radio" name="price" value="$300,000 - $400,000" v-model="enquiry.pricerange">
                    $300,000 - $400,000
                  </label>
                  <label class="radio">
                    <input type="radio" name="price" value="$400,000 - $500,000" v-model="enquiry.pricerange">
                    $400,000 - $500,000
                  </label>
                  <label class="radio">
                    <input type="radio" name="price" value="$500,000 - $600,000" v-model="enquiry.pricerange">
                    $500,000 - $600,000
                  </label>
                  <label class="radio">
                    <input type="radio" name="price" value="$600,000 - $700,000" v-model="enquiry.pricerange">
                    $600,000 - $700,000
                  </label>
                  <label class="radio">
                    <input type="radio" name="price" value="$700,000 - $800,000" v-model="enquiry.pricerange">
                    $700,000 - $800,000
                  </label>
                  <label class="radio">
                    <input type="radio" name="price" value="$800,000+" v-model="enquiry.pricerange">
                    $800,000+
                  </label>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <p class="label">Square Footage</p>
                <p class="select is-fullwidth">
                  <select name="" v-model="enquiry.squarefootage">
                    <option value="" disabled>Square Footage</option>
                    <option value="1,500-1,999 square feet">1,500-1,999 square feet</option>
                    <option value="2,000-2,499 square feet">2,000-2,499 square feet</option>
                    <option value="2,500-2,999 square feet">2,500-2,999 square feet</option>
                    <option value="3,000-3,499 square feet">3,000-3,499 square feet</option>
                    <option value="3,500-3,999 square feet">3,500-3,999 square feet</option>
                    <option value="4,000+ square feet">4,000+ square feet</option>
                  </select>
                </p>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <p class="label">Time Frame to Move</p>
                <p class="select is-fullwidth">
                  <select name="" v-model="enquiry.timeframe">
                    <option value="" disabled>Time Frame to Move</option>
                    <option value="In the next month">In the next month</option>
                    <option value="2-3 months">2-3 months</option>
                    <option value="6 months">6 months</option>
                    <option value="Sometime this year">Sometime this year</option>
                    <option value="1 year">1 year</option>
                    <option value="No rush">No rush</option>
                    <option value="Other">Other</option>
                  </select>
                </p>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <p class="label">Bedrooms</p>
                <p class="select is-fullwidth">
                  <select name="" v-model="enquiry.bedrooms">
                    <option value="" disabled>Bedrooms</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4+">4+</option>
                  </select>
                </p>
              </div>
            </div>

            <div class="column is-6">
              <div class="field">
                <p class="label">Bathrooms</p>
                <p class="select is-fullwidth">
                  <select name="" v-model="enquiry.bathrooms">
                    <option value="" disabled>Bathrooms</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4+">4+</option>
                  </select>
                </p>
              </div>
            </div>
          </div>
          <a class="button app-primary" @click="closeEnquiry">Cancel</a>
          <a class="button app-highlight" @click="submitEnquiry" :class="{'is-loading': isLoading}" :disabled="!formValid">Submit</a>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="closeEnquiry()"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-enquiry',
  data() {
    return {
      enquiry: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        pricerange: '',
        squarefootage: '',
        timeframe: '',
        bedrooms: '',
        bathrooms: '',
        builder: ''
      },
      isLoading: false,
      response: null,
      sub: null,
      showThankyou: false,
      namePattern: /^[a-zA-Z]+$/,
      emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      formValid: false,
      submitClicked: false,
    }
  },
  props: {
    product: {
      type: Object
    },
    showEnquiry: {
      type: Boolean
    }
  },
  watch: {},
  mounted() {
    this.sub = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setPublishedContact') {
        // this.response = state.communityStore.publishedContact;
        this.isLoading = false;
        this.showThankyou = true;
        this.closeEnquiry()
      }
    })
  },
  beforeDestroy() {
    this.sub()
  },
  methods: {
    submitEnquiry: function () {
      if (!this.formValid) {
        this.submitClicked = true;
      } else {
        const enquiryProduct = [
        {
          clientProductId: this.product.cpidstring,
          productName: this.product.productname,
          productPrice: this.product.productprice,
          productTypeId: '3850781445676667734',
          productStatus: this.product.currentstatusname,
          productStatusId: this.product.currentstatusid,
          active: true,
          lotCpId: null,
        }
      ];
      this.isLoading = true;
      const formData = {
        'clientid': '',
        'capsuleid': '',
        'contact': this.enquiry,
        'shortlistedProducts': enquiryProduct
      };

      const hubspotformData = {
        "fields": [
          {
            "name": "email",
            "value": this.enquiry.email
          },
          {
            "name": "firstname",
            "value": this.enquiry.firstname
          },
          {
            "name": "lastname",
            "value": this.enquiry.lastname
          },
          {
            "name": "phone",
            "value": this.enquiry.phone
          },
          {
            "name": "price_range_checkbox",
            "value": this.enquiry.pricerange
          },
          {
            "name": "square_footage",
            "value": this.enquiry.squarefootage
          },
          {
            "name": "time_frame_to_move",
            "value": this.enquiry.timeframe
          },
          {
            "name": "bedrooms",
            "value": this.enquiry.bedrooms
          },
          {
            "name": "bathrooms",
            "value": this.enquiry.bathrooms
          },
          {
            "name": "test_builder_multi",
            "value": this.product.buildername
          }
        ],
        "context": {
          "pageUri": window.location.href,
          "pageName": "Package Detail Page"
        }
      };

      this.$store.dispatch('productTracking', {
        page: 'enquiry-submit',
        product: {
          firstName: this.enquiry.firstname,
          lastName: this.enquiry.lastname,
          mobile: this.enquiry.phone,
          email: this.enquiry.email
        }
      })
      this.$store.dispatch('submitEnquiry', {formData: formData, hubspotFormData: hubspotformData})
      }
    },

    closeEnquiry: function () {
      this.enquiry = {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        productId: ''
      };
      this.showEnquiry = false;
      this.$emit('closeEnquiry', 1)
    },

    checkValidation: function () {
      if (this.enquiry.firstname !== '' &&
      this.validName(this.enquiry.firstname) &&
      this.enquiry.lastname !== '' &&
      this.validName(this.enquiry.lastname) &&
      this.validEmail(this.enquiry.email)) {
        this.formValid = true;
      } else {
        this.formValid = false;
      }
    },

    validName: function (name) {
      var re = this.namePattern;
      return re.test(name);
    },

    validEmail: function (email) {
      var re = this.emailPattern;
      return re.test(email);
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/Enquiry.vue